import { useReducer, useEffect } from 'react';

const ACTION_TYPES = {
    INIT_REQUEST: 'INIT_REQUEST',
    INIT_SUCCESS: 'INIT_SUCCESS',
    INIT_FAILURE: 'INIT_FAILURE',
    RUN_REPORTSUBSCRIPTION_REQUEST: 'RUN_REPORTSUBSCRIPTION_REQUEST',
    RUN_REPORTSUBSCRIPTION_SUCCESS: 'RUN_REPORTSUBSCRIPTION_SUCCESS',
    RUN_REPORTSUBSCRIPTION_FAILURE: 'RUN_REPORTSUBSCRIPTION_FAILURE'
  };

  const ACTIONS = {
    initRequest: () => ({
      type: ACTION_TYPES.INIT_REQUEST
    }),
    initSuccess: result => ({
      type: ACTION_TYPES.INIT_SUCCESS,
      payload: { ...result }
    }),
    initFailure: error => ({
      type: ACTION_TYPES.INIT_FAILURE,
      error
    }),
    runReportSubscriptionRequest: () => ({
      type: ACTION_TYPES.RUN_REPORTSUBSCRIPTION_REQUEST
    }),
    runReportSubscriptionSuccess: () => ({
      type: ACTION_TYPES.RUN_REPORTSUBSCRIPTION_SUCCESS
    }),
    runReportSubscriptionFailure: error => ({
      type: ACTION_TYPES.RUN_REPORTSUBSCRIPTION_FAILURE,
      error
    })
  };

  const initialState = {
    isLoading: false,
    loadingMessage: '',
    reportSubscriptions: []
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case ACTION_TYPES.INIT_REQUEST: {
        return {
          ...state,
          isLoading: true,
          loadingMessage: 'Initializing page'
        };
      }
  
      case ACTION_TYPES.INIT_SUCCESS: {
        const { payload } = action;
        return {
          ...state,
          isLoading: false,
          loadingMessage: '',
          reportSubscriptions: payload.subscriptions
        };
      }
  
      case ACTION_TYPES.INIT_FAILURE: {
        return {
          ...state,
          isLoading: false,
          isFailedInit: true,
          loadingMessage: '',
          reportSubscriptions: []
        };
      }
  
      case ACTION_TYPES.RUN_REPORTSUBSCRIPTION_REQUEST: {
        return {
          ...state,
          isLoading: true,
          loadingMessage: 'Submitting report subscription request'
        };
      }
  
      case ACTION_TYPES.RUN_REPORTSUBSCRIPTION_SUCCESS: {
        return {
          ...state,
          isLoading: false,
          loadingMessage: ''
        };
      }
  
      case ACTION_TYPES.RUN_REPORTSUBSCRIPTION_FAILURE: {
        return {
          ...state,
          isLoading: false,
          loadingMessage: ''
        };
      }
  
      default: {
        throw new Error('reportsubscriptionservicehook reducer default should never hit');
      }
    }
  };

  const useReportSubscriptionService = service => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const runReportSubscription = subscriptionId => {
        dispatch(ACTIONS.runReportSubscriptionRequest());

        service.runReportSubscription(subscriptionId)
            .then(result => dispatch(ACTIONS.runReportSubscriptionSuccess(result)))
            .catch(e => dispatch(ACTIONS.runReportSubscriptionFailure(e.toString())));
    };

    const boundActions = {
        runReportSubscription
      };
    
      // init
      useEffect(() => {
        dispatch(ACTIONS.initRequest());
    
        service.init()
          .then(responseJson => {
            dispatch(ACTIONS.initSuccess(responseJson));
          })
          .catch(e => dispatch(ACTIONS.initFailure(e.toString())));
      }, []);

      return [
        {
          ...state,
          isLoading: state.isPageLoading,
          loadingMessage: state.loadingMessage
        },
        boundActions
      ];
  };

  export default useReportSubscriptionService;